import * as yup from "yup";

export const schema = yup.object().shape({
  vote_id: yup.number().notRequired(),
  status_id: yup.number().notRequired(),
  comment: yup.string().required().min(3).max(500),
});
